import { render, staticRenderFns } from "./ModalMoverMultiplesDocumentos.vue?vue&type=template&id=a20edfb4&scoped=true&"
import script from "./ModalMoverMultiplesDocumentos.vue?vue&type=script&lang=js&"
export * from "./ModalMoverMultiplesDocumentos.vue?vue&type=script&lang=js&"
import style0 from "./ModalMoverMultiplesDocumentos.vue?vue&type=style&index=0&id=a20edfb4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a20edfb4",
  null
  
)

export default component.exports